import { useMutation } from 'react-query';
import config from '../config';

const confirmSelectRequest = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return { success: true, skipped: true };
  }

  const request = await fetch(`${config.apiUrl}/confirm-selection`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'include',
  });

  if (!request.ok) {
    throw new Error('Failed to confirm selection');
  }

  return request.json();
};

export const useConfirmSelect = () => {
  return useMutation(confirmSelectRequest);
};
